import { render, staticRenderFns } from "./Recognise.vue?vue&type=template&id=57090d1d&"
import script from "./Recognise.vue?vue&type=script&lang=js&"
export * from "./Recognise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports